module.exports = __webpack_public_path__ + "static/media/17.88920af2.jpg";